import { FC, useMemo } from 'react'
import BigPush, { BigPushProps } from 'src/components/BigPush'
import { ButtonTransformer } from 'src/relay/Transformers/ButtonTransormer'
import {
  ImageTransformer,
  unwrapMedia,
} from 'src/relay/Transformers/ImageTransformer'
import { getThemeColor } from 'src/relay/Transformers/ThemeTransformer'
import { RichTextTransformer } from 'src/relay/Transformers/RichTextTransformer'

import { BlockProps } from '../props'

import { BigPushBlockProps } from './props'

const BigPushBlock: FC<BlockProps<BigPushBlockProps>> = ({
  data,
  configuration,
  locale,
}) => {
  const props: BigPushProps = useMemo(
    () => ({
      title: data.title || '',
      ...(data.text && {
        richTextProps: RichTextTransformer(data.text, configuration, locale),
      }),
      actionButtonProps: ButtonTransformer({
        data: data.cta,
        theme: data.theme?.data,
      }),
      pictureProps: {
        imageProps: ImageTransformer(unwrapMedia(data.desktopImage)),
        mobileImageProps: ImageTransformer(unwrapMedia(data.mobileImage)),
      },
      color: getThemeColor(data.theme?.data),
    }),
    [configuration, data, locale]
  )

  return <BigPush {...props} />
}

export default BigPushBlock
